(() => {
  if (window.XootrCartAccessoriesLoaded) return;
  window.XootrCartAccessoriesLoaded = true;

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-xootr-add-accessory]');
    if (!button || button.disabled) return;

    const variantId = button.dataset.variantId;
    if (!variantId) return;

    const label = button.querySelector('[data-xootr-add-label]');
    const loading = button.querySelector('[data-xootr-add-loading]');

    button.disabled = true;

    if (label) label.hidden = true;
    if (loading) loading.hidden = false;

    try {
      const addResponse = await fetch(
        `${window.Shopify.routes.root}cart/add.js`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({
            items: [
              {
                id: Number(variantId),
                quantity: 1,
              },
            ],
          }),
        }
      );

      const addResult = await addResponse.json();

      if (!addResponse.ok || addResult.status) {
        throw new Error(
          addResult.description ||
          addResult.message ||
          'Unable to add accessory.'
        );
      }

      const cartResponse = await fetch(
        `${window.Shopify.routes.root}cart.js`
      );

      const cart = await cartResponse.json();
/*
 * Update Dawn cart icon count immediately.
 */
const cartIconBubble = document.querySelector('#cart-icon-bubble');

if (cartIconBubble) {
  let countBubble = cartIconBubble.querySelector('.cart-count-bubble');

  if (cart.item_count > 0) {
    if (!countBubble) {
      countBubble = document.createElement('div');
      countBubble.className = 'cart-count-bubble';

      countBubble.innerHTML = `
        <span aria-hidden="true"></span>
        <span class="visually-hidden"></span>
      `;

      cartIconBubble.appendChild(countBubble);
    }

    const visibleCount = countBubble.querySelector(
      'span[aria-hidden="true"]'
    );

    const accessibleCount = countBubble.querySelector(
      '.visually-hidden'
    );

    if (visibleCount) {
      visibleCount.textContent = cart.item_count;
    }

    if (accessibleCount) {
      accessibleCount.textContent =
        `${cart.item_count} items`;
    }
  } else if (countBubble) {
    countBubble.remove();
  }
}
      /*
       * Reload the page section HTML so Liquid sees
       * the complete updated cart.
       */
      const sectionResponse = await fetch(
        `${window.location.pathname}?section_id=cart-notification-product`
      );

      const sectionHTML = await sectionResponse.text();

      const parsed = new DOMParser().parseFromString(
        sectionHTML,
        'text/html'
      );

      /*
       * The section contains one notification block per
       * cart item. Combine their inner product markup.
       */
      const products = parsed.querySelectorAll(
        '[id^="cart-notification-product-"]'
      );

      const target = document.getElementById(
        'cart-notification-product'
      );

      if (target && products.length) {
        target.innerHTML = '';

        products.forEach((product) => {
          target.append(...product.childNodes);
        });
      }

      const viewCartButton = document.getElementById(
        'cart-notification-button'
      );

      if (viewCartButton) {
        viewCartButton.textContent =
          `View cart (${cart.item_count})`;
      }

    } catch (error) {
      console.error('Xootr accessory add error:', error);

      button.disabled = false;

      if (label) label.hidden = false;
      if (loading) loading.hidden = true;
    }
  });
})();